// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Main from './main.vue'
import ViewUI from 'view-design';
import Qs from 'qs'
import dayjs from 'dayjs'
import Router from '@/router'
import Axios from '@/utils/axios'
import Store from '@/store/store'
import Env from '@/config/env.modal'
import GetSite from '@/config/api.modal'
import Global from '@/utils/global'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'view-design/dist/styles/iview.css';
import '../../static/css/common/base.css'
import '../../static/css/common/style.css?v=1.0.1'
import '../../static/css/common/layout.scss'
import '../../static/css/common/modal.scss'
import '../../static/css/system/style.scss'
import '../../static/css/enter/main.scss'
import '../../static/css/enter/media.scss'

Vue.use(ElementUI);
Vue.use(ViewUI);
Vue.prototype.dayjs = dayjs //时间格式化
Vue.config.productionTip = false;
//设置接口域名
Vue.prototype.$api_site = GetSite(Env);
Vue.prototype.$axios = Axios; //引用axios
Vue.prototype.$qs = Qs; //qs模块，post data
Vue.prototype.$global = Global; //公共方法

new Vue({
  el: '#app',
  router: Router,
  store: Store,
  components: { Main },
  template: '<Main/>',
})



// WEBPACK FOOTER //
// ./src/view/main.js